import React from "react";
import "./LogoutCard.scss";
import { useKeycloak } from "@react-keycloak/web";
import LogoutIcon from '../../images/Logout-Icon.svg';
import CustomTooltip from "../Tooltip/Tooltip";
import { unifiedPageUrl } from "../../services/axiosConfig";

const LogoutDropdownCard = (props) => {
  const { getFirstLetters, getUserNameEmail } = props;
  const { keycloak } = useKeycloak();
  const host = window.location.host;

  const userLogout = () => {
    //  keycloak.logout();
      keycloak.logout({ redirectUri: unifiedPageUrl });
    localStorage.removeItem("dontShowAgain");
  };

  const userName = getUserNameEmail?.userInfo.name.split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

  return (
    <div className="logoutCard">
      <div className="d-flex align-items-center logout-container">
        <div className="logout-user-info">
          <h3>{getFirstLetters()}</h3>
        </div>
        <div className="logout-info-details">
          <CustomTooltip title={userName} classes="user-profile-tooltip">
            <h3 className="logout-info-name">{userName}</h3>
          </CustomTooltip>
          <CustomTooltip title={getUserNameEmail?.userInfo.email} classes="user-profile-tooltip">
            <h3 className="logout-info-email">{getUserNameEmail?.userInfo.email}</h3>
          </CustomTooltip>
        </div>
      </div>
      <div className="d-flex align-items-center logout-button" onClick={userLogout}>
        <img src={LogoutIcon} alt="" width={16} height={16} />
        <span>Log Out</span>
      </div>

      {/* <div className="userNameOuterLine">
        {getFirstLetters()}
      </div> */}
      {/* <div className="d-flex justify-content-center">
        <div className="userNameOuterLine">
          <span className="userName23"> {getFirstLetters()}</span>
        </div>
      </div>
      <div className="logoutCardName">{getUserNameEmail?.userInfo.name}</div>
      <div className="logoutCardEmail">{getUserNameEmail?.userInfo.email}</div>
      <div className="text-center">
        <button
          className={`btn  logoutBtn`}
          type="button"
          onClick={userLogout}
        >
          Logout
        </button>
      </div> */}
    </div>
  );
};
export default LogoutDropdownCard;
